import React from 'react';
import {Link, useLocation} from 'react-router-dom';

// Second-row navigation for the public SMI sections (approved six-page restyle, 2026-09-30).
export const SECTIONS = [['Verify', '/verify'], ['Library', '/library'], ['Games', '/play'], ['Community', '/network'], ['Membership', '/membership'], ['Roadmap', '/roadmap']];
const PREFIXES = [...SECTIONS.map(([, to]) => to), '/registry', '/modules', '/licensing'];
export const isSectionPath = path => PREFIXES.some(p => path === p || path.startsWith(`${p}/`));
const owner = path => {
  if (path.startsWith('/registry') || path.startsWith('/licensing')) return '/verify';
  if (path.startsWith('/modules')) return '/play';
  return SECTIONS.find(([, to]) => path === to || path.startsWith(`${to}/`))?.[1];
};

export const SectionNav = () => {
  const {pathname} = useLocation();
  const current = owner(pathname);
  return <nav className="sp-section-nav" aria-label="SMI sections" data-testid="section-nav"><div className="signal-container">
    {SECTIONS.map(([label, to]) => <Link key={to} to={to} aria-current={current === to ? 'page' : undefined} data-testid={`section-nav-${label.toLowerCase()}`}>{label}</Link>)}
  </div></nav>;
};
